export const NAV_HEIGHT = {
  mobile: 60,
  desktop: 144,
} as const;

export function navOffset(
  variant: 'default' | 'minimal' | 'checkout-steps',
  mobileSearch = false,
): string {
  if (variant === 'minimal') {
    return 'pt-[60px] desktop:pt-[77px]';
  }

  if (variant === 'checkout-steps') {
    return 'pt-[96px] desktop:pt-[134px]';
  }

  if (mobileSearch) {
    return 'pt-[140px] desktop:pt-[144px]';
  }

  return `pt-[${NAV_HEIGHT.mobile}px] desktop:pt-[${NAV_HEIGHT.desktop}px]`;
}
